export const getMedicationsSetupForReport = (medications) => {
  const medicationsMap = {}
  for (let m of medications){
    const {name, dosage, reminders} = m
    if(!reminders.length){
      const key = `${name}${dosage}`
      medicationsMap[key] = {name, dosage, timesPerDay: '', days: ''}
    } else{
      reminders.map(r => {
        const {days} = r
        const key = `${name}${dosage}${days}`
        if(!medicationsMap[key]){
          medicationsMap[key] = {name, dosage, days, timesPerDay: days ? 1 : ''}
        } else{
          const timesPerDay = days ? medicationsMap[key].timesPerDay + 1 : ''
          medicationsMap[key].timesPerDay = timesPerDay
        }
      })
     
    }
  }
  const medicationsArr = Object.values(medicationsMap)
  const sortedMedications = medicationsArr?.sort((a, b) => a?.name.localeCompare(b?.name))
  return sortedMedications
}